export default [
  [`Размеры`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `40`, `42`, `44`, `46`, `48`, `50`, `52`],
  [`Рост`, `164`, `164`, `170`, `170`, `170`, `170`, `170`],
  [`Обхват груди (a)`, `80`, `84`, `88`, `92`, `96`, `100`, `104`],
  [`Обхват бёдер (b)`, `86`, `90`, `94`, `98`, `102`, `106`, `110`],
  [`Длина спины по центру (c)`, `56`, `56`, `56`, `61`, `61`, `65`, `65`],
  [`Ширина на уровне проймы (d)`, `48`, `50`, `52`, `54`, `56`, `58`, `61`],
  [`Ширина рукава вверху (e)`, `17`, `17`, `18`, `19`, `19`, `20`, `21`],
  [`Длина рукава (f)`, `62`, `62`, `64`, `65`, `65`, `66`, `67`]
];
